import {useCallback} from 'react';

import {MessageModel, MessageVisualStatusesEnum} from '../../../libs/shared/core/src/models/api/messageModel';
import {getUserTimeZone} from '../../../libs/shared/core/src/store/data/preferences/commonPreferencesSelectors';
import {useAppSelector} from '../../helpers/appReduxHelpers';
import {openEmlPrintPopup, openMessagePrintPopup} from '../../services/popups';
import {EmlSource} from '../../store/panels/eml/emlPanelState';

export function useMessagePrintHandler(message: MessageModel | undefined, emlSource?: EmlSource) {
  const userTimeZone = useAppSelector(getUserTimeZone);
  return useCallback(() => {
    if (!message || message.visualStatus === MessageVisualStatusesEnum.PARTIAL) {
      return;
    }

    if (emlSource) {
      openEmlPrintPopup(message, emlSource, userTimeZone);
    } else {
      openMessagePrintPopup(message, userTimeZone);
    }
  }, [emlSource, message, userTimeZone]);
}
